<template>
  <a-modal
    v-model="showModal"
    title="扫码绑定微信公众号"
    :closable="false"
    :keyboard="false"
    :maskClosable="false"
    :destroyOnClose="true"
    wrapClassName="bind-weChat-email-modal"
    width="415px"
  >
    <div class="modal-content">
      <div class="tips-text">请扫描关注我们的微信公众号，以便第一时间获得商标监控通知。</div>
      <div class="qr-code">
        <span v-if="loadding">加载中...</span>
        <img :src="qrCode" v-else-if="qrCode" />
      </div>
    </div>
    <template slot="footer">
      <a-button type="primary" @click="showModal = false">关闭</a-button>
    </template>
  </a-modal>
</template>
<script>
import { getWxQrcode, checkWxBind } from '@/api/trademarkRegister/trademarkMonitor';

export default {
  components: {},
  data() {
    return {
      showModal: false,
      loadding: false,
      qrCode: '',
      isBind: false,
      time: null,
    };
  },
  watch: {
    showModal(val) {
      if (val) {
        this.loadding = true;
        this.qrCode = '';
        this.isBind = false;
        this.changeWx();
      } else {
        clearTimeout(this.time);
      }
    },
  },
  created() {},
  mounted() {},
  methods: {
    //绑定微信公众号
    changeWx() {
      this.loadding = true;
      getWxQrcode({
        enterpriseCode: localStorage.getItem('enterpriseCode'),
      })
        .then((res) => {
          this.loadding = false;
          if (res.code === 0) {
            this.qrCode = res.data;
            this.checkWxBind();
          }
        })
        .catch((e) => {
          this.loadding = false;
        });
    },
    //检测是否绑定微信公众号
    checkWxBind() {
      checkWxBind().then((res) => {
        if (res.code === 0 && res.data && JSON.stringify(res.data) !== '{}') {
          this.$Message.success('绑定成功');
          this.isBind = true;
          this.showModal = false;
          this.$emit('bindSuccess', true);
        } else {
          this.time = setTimeout(() => {
            this.checkWxBind();
          }, 1000);
        }
      });
    },
  },
  beforeDestroy() {
    clearTimeout(this.time);
  },
};
</script>
<style lang="less" scoped>
.modal-content {
  .tips-text {
    line-height: 22px;
    font-size: 14px;
    color: #606266;
    margin-bottom: 16px;
  }
  .qr-code {
    width: 200px;
    height: 200px;
    line-height: 200px;
    text-align: center;
    overflow: hidden;
    background-color: #d9d9d9;
    margin: 20px auto;
    img {
      width: 100%;
      height: 100%;
      float: left;
    }
  }
}
/deep/ .bind-weChat-email-modal {
  .ant-modal-header,
  .ant-modal-footer {
    border: none;
  }
  .ant-modal-body {
    padding: 0 24px;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/myBrand/trademarkMonitor/component/BindWxQrcode.vue